import { FC, memo } from 'react';

import V2ProductsPresenter from './V2ProductsPresenter';

const V2Products: FC = memo(() => (
  <V2ProductsPresenter />
));

export default V2Products;
